export default {
  // 首页广告位
  home: 'https://main.qcloudimg.com/raw/b5828e9dd3449ac4d9a3ede8c1e33b76.jpg',
  // 文章列表页广告位
  articleList: 'https://main.qcloudimg.com/raw/b33652bdfbd062b804db1b30e11df335.png',
  // 列表页详情广告位
  article:
    'https://img.serverlesscloud.cn/2020720/1595246916361-3.%20%E6%96%87%E7%AB%A0%E9%98%85%E8%AF%BB%E9%A1%B5%E5%BA%95%E9%83%A8%E5%B9%BF%E5%91%8A0720%402x.png',
}
